var map = {
  "./icon-academic-cap.png": "11137",
  "./icon-adjustments-horizontal.png": "84",
  "./icon-adjustments-vertical.png": "63257",
  "./icon-archive-box-arrow-down.png": "42291",
  "./icon-archive-box-x-mark.png": "22969",
  "./icon-archive-box.png": "90592",
  "./icon-arrow-down-circle.png": "10874",
  "./icon-arrow-down-left.png": "45795",
  "./icon-arrow-down-on-square-stack.png": "45471",
  "./icon-arrow-down-on-square.png": "22206",
  "./icon-arrow-down-right.png": "30571",
  "./icon-arrow-down-tray.png": "18787",
  "./icon-arrow-down.png": "27799",
  "./icon-arrow-left-circle.png": "11862",
  "./icon-arrow-left-on-rectangle.png": "43350",
  "./icon-arrow-left.png": "58818",
  "./icon-arrow-long-down.png": "42541",
  "./icon-arrow-long-left.png": "58855",
  "./icon-arrow-long-right.png": "5251",
  "./icon-arrow-long-up.png": "81485",
  "./icon-arrow-path-rounded-square.png": "52292",
  "./icon-arrow-path.png": "6137",
  "./icon-arrow-right-circle.png": "37213",
  "./icon-arrow-right-on-rectangle.png": "63825",
  "./icon-arrow-right.png": "30679",
  "./icon-arrow-small-down.png": "16544",
  "./icon-arrow-small-left.png": "63030",
  "./icon-arrow-small-right.png": "14162",
  "./icon-arrow-small-up.png": "74199",
  "./icon-arrow-top-right-on-square.png": "79447",
  "./icon-arrow-trending-down.png": "50877",
  "./icon-arrow-trending-up.png": "79968",
  "./icon-arrow-up-circle.png": "37854",
  "./icon-arrow-up-left.png": "75787",
  "./icon-arrow-up-on-square-stack.png": "92965",
  "./icon-arrow-up-on-square.png": "87201",
  "./icon-arrow-up-right.png": "97303",
  "./icon-arrow-up-tray.png": "59602",
  "./icon-arrow-up.png": "29150",
  "./icon-arrow-uturn-down.png": "86734",
  "./icon-arrow-uturn-left.png": "18482",
  "./icon-arrow-uturn-right.png": "4314",
  "./icon-arrow-uturn-up.png": "69282",
  "./icon-arrows-pointing-in.png": "12694",
  "./icon-arrows-pointing-out.png": "63037",
  "./icon-arrows-right-left.png": "18304",
  "./icon-arrows-up-down.png": "78702",
  "./icon-at-symbol.png": "79879",
  "./icon-backspace.png": "58504",
  "./icon-backward.png": "6055",
  "./icon-banknotes.png": "29890",
  "./icon-bars-2.png": "20001",
  "./icon-bars-3-bottom-left.png": "64782",
  "./icon-bars-3-bottom-right.png": "53994",
  "./icon-bars-3-center-left.png": "74425",
  "./icon-bars-3.png": "93513",
  "./icon-bars-4.png": "46418",
  "./icon-bars-arrow-down.png": "4683",
  "./icon-bars-arrow-up.png": "73150",
  "./icon-battery-0.png": "43174",
  "./icon-battery-100.png": "57883",
  "./icon-battery-50.png": "57073",
  "./icon-beaker.png": "69161",
  "./icon-bell-alert.png": "43744",
  "./icon-bell-slash.png": "18402",
  "./icon-bell-snooze.png": "79237",
  "./icon-bell.png": "84752",
  "./icon-bolt-slash.png": "46606",
  "./icon-bolt.png": "95238",
  "./icon-book-open.png": "70024",
  "./icon-bookmark-slash.png": "68823",
  "./icon-bookmark-square.png": "15035",
  "./icon-bookmark.png": "65150",
  "./icon-briefcase.png": "61743",
  "./icon-bug-ant.png": "36135",
  "./icon-building-library.png": "46437",
  "./icon-building-office-2.png": "73674",
  "./icon-building-office.png": "66696",
  "./icon-building-storefront.png": "39515",
  "./icon-cake.png": "20442",
  "./icon-calculator.png": "98517",
  "./icon-calendar-days.png": "42217",
  "./icon-calendar.png": "17656",
  "./icon-camera.png": "52645",
  "./icon-chart-bar-square.png": "37250",
  "./icon-chart-bar.png": "9404",
  "./icon-chart-pie.png": "89830",
  "./icon-chat-bubble-bottom-center-text.png": "31234",
  "./icon-chat-bubble-bottom-center.png": "74032",
  "./icon-chat-bubble-left-ellipsis.png": "6653",
  "./icon-chat-bubble-left-right.png": "74238",
  "./icon-chat-bubble-left.png": "45338",
  "./icon-chat-bubble-oval-left-ellipsis.png": "67753",
  "./icon-chat-bubble-oval-left.png": "70888",
  "./icon-check-badge.png": "68634",
  "./icon-check-circle.png": "91706",
  "./icon-check.png": "70041",
  "./icon-chevron-double-down.png": "50088",
  "./icon-chevron-double-left.png": "6027",
  "./icon-chevron-double-right.png": "27397",
  "./icon-chevron-double-up.png": "98677",
  "./icon-chevron-down.png": "24877",
  "./icon-chevron-left.png": "1687",
  "./icon-chevron-right.png": "78236",
  "./icon-chevron-up-down.png": "58804",
  "./icon-chevron-up.png": "89995",
  "./icon-circle-stack.png": "15385",
  "./icon-clipboard-document-check.png": "90781",
  "./icon-clipboard-document-list.png": "35296",
  "./icon-clipboard-document.png": "50149",
  "./icon-clipboard.png": "58426",
  "./icon-clock.png": "48728",
  "./icon-cloud-arrow-down.png": "89642",
  "./icon-cloud-arrow-up.png": "78993",
  "./icon-cloud.png": "35587",
  "./icon-code-bracket-square.png": "29400",
  "./icon-code-bracket.png": "59928",
  "./icon-cog-6-tooth.png": "2823",
  "./icon-cog-8-tooth.png": "99555",
  "./icon-cog.png": "51200",
  "./icon-command-line.png": "60339",
  "./icon-computer-desktop.png": "76085",
  "./icon-cpu-chip.png": "10401",
  "./icon-credit-card.png": "15621",
  "./icon-cube-transparent.png": "6321",
  "./icon-cube.png": "78109",
  "./icon-currency-bangladeshi.png": "69200",
  "./icon-currency-dollar.png": "4202",
  "./icon-currency-euro.png": "35320",
  "./icon-currency-pound.png": "21174",
  "./icon-currency-rupee.png": "76949",
  "./icon-currency-yen.png": "49938",
  "./icon-cursor-arrow-rays.png": "82657",
  "./icon-cursor-arrow-ripple.png": "72305",
  "./icon-device-phone-mobile.png": "13642",
  "./icon-device-tablet.png": "52376",
  "./icon-document-arrow-down.png": "57907",
  "./icon-document-arrow-up.png": "92564",
  "./icon-document-chart-bar.png": "62529",
  "./icon-document-check.png": "56261",
  "./icon-document-duplicate.png": "76845",
  "./icon-document-magnifying-glass.png": "119",
  "./icon-document-minus.png": "53851",
  "./icon-document-plus.png": "31235",
  "./icon-document-text.png": "45988",
  "./icon-document.png": "62102",
  "./icon-ellipsis-horizontal-circle.png": "75831",
  "./icon-ellipsis-horizontal.png": "24718",
  "./icon-ellipsis-vertical.png": "87359",
  "./icon-envelope-open.png": "79824",
  "./icon-envelope.png": "43045",
  "./icon-exclamation-circle.png": "22529",
  "./icon-exclamation-triangle.png": "44476",
  "./icon-eye-dropper.png": "60855",
  "./icon-eye-slash.png": "99453",
  "./icon-eye.png": "91166",
  "./icon-face-frown.png": "17233",
  "./icon-face-smile.png": "5617",
  "./icon-film.png": "24937",
  "./icon-finger-print.png": "5981",
  "./icon-fire.png": "58169",
  "./icon-flag.png": "89620",
  "./icon-folder-arrow-down.png": "20961",
  "./icon-folder-minus.png": "63316",
  "./icon-folder-open.png": "58591",
  "./icon-folder-plus.png": "67594",
  "./icon-folder.png": "37024",
  "./icon-forward.png": "67937",
  "./icon-funnel.png": "11267",
  "./icon-gif.png": "94236",
  "./icon-gift-top.png": "22661",
  "./icon-gift.png": "60626",
  "./icon-globe-alt.png": "75876",
  "./icon-globe-americas.png": "37314",
  "./icon-globe-asia-australia.png": "37921",
  "./icon-globe-europe-africa.png": "61336",
  "./icon-hand-raised.png": "60868",
  "./icon-hand-thumb-down.png": "77660",
  "./icon-hand-thumb-up.png": "69025",
  "./icon-hashtag.png": "25439",
  "./icon-heart.png": "81988",
  "./icon-home-modern.png": "4850",
  "./icon-home.png": "52259",
  "./icon-identification.png": "89840",
  "./icon-inbox-arrow-down.png": "37301",
  "./icon-inbox-stack.png": "78498",
  "./icon-inbox.png": "80061",
  "./icon-information-circle.png": "62938",
  "./icon-key.png": "91595",
  "./icon-language.png": "46676",
  "./icon-lifebuoy.png": "65654",
  "./icon-light-bulb.png": "40492",
  "./icon-link.png": "77367",
  "./icon-list-bullet.png": "12169",
  "./icon-lock-closed.png": "78736",
  "./icon-lock-open.png": "80134",
  "./icon-magnifying-glass-circle.png": "80784",
  "./icon-magnifying-glass-minus.png": "68842",
  "./icon-magnifying-glass-plus.png": "34391",
  "./icon-magnifying-glass.png": "29775",
  "./icon-map-pin.png": "74965",
  "./icon-map.png": "95555",
  "./icon-megaphone.png": "35714",
  "./icon-microphone.png": "79540",
  "./icon-minus-circle.png": "85207",
  "./icon-minus-small.png": "50576",
  "./icon-minus.png": "9670",
  "./icon-moon.png": "19517",
  "./icon-musical-note.png": "491",
  "./icon-newspaper.png": "67430",
  "./icon-no-symbol.png": "30529",
  "./icon-paint-brush.png": "77491",
  "./icon-paper-airplane.png": "62438",
  "./icon-paper-clip.png": "75751",
  "./icon-pause-circle.png": "12960",
  "./icon-pause.png": "21716",
  "./icon-pencil-square.png": "2390",
  "./icon-pencil.png": "66324",
  "./icon-phone-arrow-down-left.png": "73244",
  "./icon-phone-arrow-up-right.png": "89625",
  "./icon-phone-x-mark.png": "69926",
  "./icon-phone.png": "13400",
  "./icon-photo.png": "29811",
  "./icon-play-circle.png": "99685",
  "./icon-play-pause.png": "40248",
  "./icon-play.png": "20042",
  "./icon-plus-circle.png": "78742",
  "./icon-plus-small.png": "2566",
  "./icon-plus.png": "36089",
  "./icon-power.png": "60419",
  "./icon-presentation-chart-bar.png": "22026",
  "./icon-presentation-chart-line.png": "16647",
  "./icon-printer.png": "6576",
  "./icon-puzzle-piece.png": "58642",
  "./icon-qr-code.png": "83010",
  "./icon-question-mark-circle.png": "52220",
  "./icon-queue-list.png": "70162",
  "./icon-radio.png": "36917",
  "./icon-receipt-percent.png": "83441",
  "./icon-receipt-refund.png": "43681",
  "./icon-rectangle-group.png": "79614",
  "./icon-rectangle-stack.png": "33296",
  "./icon-rocket-launch.png": "80073",
  "./icon-rss.png": "57724",
  "./icon-scale.png": "40703",
  "./icon-scissors.png": "54324",
  "./icon-server-stack.png": "48482",
  "./icon-server.png": "38039",
  "./icon-share.png": "52863",
  "./icon-shield-check.png": "77833",
  "./icon-shield-exclamation.png": "89081",
  "./icon-shopping-bag.png": "7981",
  "./icon-shopping-cart.png": "90411",
  "./icon-signal-slash.png": "87181",
  "./icon-signal.png": "13866",
  "./icon-sparkles.png": "39524",
  "./icon-speaker-wave.png": "24160",
  "./icon-speaker-x-mark.png": "20547",
  "./icon-square-2-stack.png": "17343",
  "./icon-square-3-stack-3d.png": "39873",
  "./icon-squares-2x2.png": "84455",
  "./icon-squares-plus.png": "47366",
  "./icon-star.png": "29279",
  "./icon-stop-circle.png": "17344",
  "./icon-stop.png": "42330",
  "./icon-sun.png": "6266",
  "./icon-swatch.png": "26640",
  "./icon-table-cells.png": "29995",
  "./icon-tag.png": "88704",
  "./icon-ticket.png": "7990",
  "./icon-trash.png": "14798",
  "./icon-trophy.png": "82370",
  "./icon-truck.png": "97951",
  "./icon-tv.png": "71130",
  "./icon-user-circle.png": "82459",
  "./icon-user-group.png": "69048",
  "./icon-user-minus.png": "87444",
  "./icon-user-plus.png": "90783",
  "./icon-user.png": "35195",
  "./icon-users.png": "80223",
  "./icon-variable.png": "67736",
  "./icon-video-camera-slash.png": "44026",
  "./icon-video-camera.png": "7086",
  "./icon-view-columns.png": "16353",
  "./icon-viewfinder-circle.png": "93620",
  "./icon-wallet.png": "28595",
  "./icon-wifi.png": "17802",
  "./icon-window.png": "20131",
  "./icon-wrench-screwdriver.png": "1190",
  "./icon-wrench.png": "46027",
  "./icon-x-circle.png": "34785",
  "./icon-x-mark.png": "69890"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85912;
